module.exports = __webpack_public_path__ + "img/plat1.0ddd1f71.png";